import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { IConfig, NgxMaskModule } from 'ngx-mask';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorsService } from './services/interceptors.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { UploadComponent } from './upload/upload.component';
import { LoadingInterceptor } from './services/loading.interceptor';
import { LoadingComponent } from './loading/loading.component';

const mask: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [AppComponent, UploadComponent, LoadingComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(mask),
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      //timeOut: 5000,
      positionClass: 'toast-top-full-width',
      preventDuplicates: false,
      closeButton: true,
      enableHtml: true,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorsService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
